import { DollarSign } from "lucide-react";

export const CASHAPP_TAG = "$fountain111";
export const CASHAPP_URL = `https://cash.app/${CASHAPP_TAG}`;

export default function CashAppLine({ size = "md", testId }) {
  const cls =
    size === "sm"
      ? "px-5 py-2.5 text-sm gap-2"
      : "px-7 py-4 gap-3";
  return (
    <a
      href={CASHAPP_URL}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-center rounded-full bg-[#00D632] text-black font-medium hover:bg-[#00c02d] transition-colors whitespace-nowrap ${cls}`}
      data-testid={testId}
    >
      <DollarSign className={size === "sm" ? "w-4 h-4" : "w-5 h-5"} /> Give instantly via Cash App — {CASHAPP_TAG}
    </a>
  );
}
